export const thumbnailShortTransformation = {
  128: [83.30159, 55.534393, 44.698414, 55.534393, 64.33862, 78.560844],
  96: [62.4761925, 41.65079475, 33.523810499999996, 41.65079475, 48.25396500000001, 58.920633],
  64: [41.650795, 27.7671965, 22.349207, 27.7671965, 32.16931, 39.280422],
  32: [20.8253975, 13.88359825, 11.1746035, 13.88359825, 16.084655, 19.640211],
};

export const thumbnailFullTransformation = {
  128: [
    44.698414,
    55.534393,
    83.30159,
    55.534393,
    64.33862,
    78.560844,
    64.33862,
    98.20106,
    20.317461,
    71.78836,
    104.97354,
    73.14286,
  ],
  96: [
    33.52381,
    41.650795,
    62.476192,
    41.650795,
    48.253967,
    58.92063,
    48.253967,
    73.650795,
    15.238096,
    53.84127,
    78.730156,
    54.857147,
  ],
  64: [
    22.349207,
    27.767197,
    41.650795,
    27.767197,
    32.16931,
    39.280422,
    32.16931,
    49.10053,
    10.1587305,
    35.89418,
    52.48677,
    36.57143,
  ],
  32: [
    11.174603,
    13.883598,
    20.825397,
    13.883598,
    16.084656,
    19.640211,
    16.084656,
    24.550264,
    5.0793653,
    17.94709,
    26.243385,
    18.285715,
  ],
};

export const THERMAL_MODES = {
  stream: 'stream',
  images: 'images',
};
